import { useEffect } from "react";
import { Box } from "@mui/system";

import CardPrimary from "../../components/Card/Card.Primary";
import config from "../../config/aws-exports";

import { cardSecondarySettings, settings } from "../Home/SlickSettings";
import Slider from "react-slick";
import { useDispatch, useSelector } from "react-redux";
import { authData } from "../../redux/auth/authSlice";
// import CardSecondary from "../../components/Card/Card.Secondary";
import { HeadingPrimary } from "../../components/Styles/Heading";
import { Link, useNavigate } from "react-router-dom";
import Skeleton from "@mui/material/Skeleton";
// import useFetch from "../../Hooks/useFetch";
import { useQuery } from "react-query";
import { API } from "aws-amplify";
import { session } from "../../redux/Session/Session";
import moment from "moment";
import { Stack } from "@mui/material";
import styled from "styled-components";
import { sessionAll } from "../../redux/viewAll/viewAll";
import CardSecondary from "../../components/Card/Card.Secondary";
import CardTopicsSecondary from "../../components/Card/Card.Secondary.Topics";
import emptysearch from "../../assets/Nothing here yet.gif";
import "./Dashboard.css";
export const CusLink = styled(Link)`
  color: ${({ theme }) => theme.color.secondary};
`;

export const SkeletonData = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "2rem",
    }}
  >
    {[...Array(5)].map((item, id) => (
      <Box key={id}>
        <Skeleton variant="rectangular" width={310} height={218} />
        <Box sx={{ pt: 0.5 }}>
          <Skeleton />
          <Skeleton width="60%" />
        </Box>
      </Box>
    ))}
  </Box>
);
export default function Dashboard() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userDetails = useSelector(authData);

  //popular course
  const { data } = useQuery("popularSessionAndCourse", () =>
    API.post(config.aws_cloud_logic_custom_name, "/getWebSessionAndCourse", {
      body: {
        schema: config.schema,
        tenant: userDetails?.uData?.oid,
        ur_id: userDetails?.uData?.ur_id,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        // Authorization: jwttoken,
      },
    })
      .then((res) => {
        return res;
      })
      .catch((err) => console.error(err)),
  );

  const dashboardData = useQuery(
    [
      "dashboard",
      {
        tenant: userDetails?.uData?.oid,
        eid: userDetails?.sub,
        ur_id: userDetails?.uData?.ur_id,
        schema: config.schema,
      },
    ],
    async () => {
      try {
        // const id = await parseInt(window.localStorage.getItem("ur_id"));
        const res = await API.post(
          config.aws_cloud_logic_custom_name,
          "/dashboard",
          {
            body: {
              tenant: userDetails?.uData?.oid,
              eid: userDetails?.sub,
              ur_id: userDetails?.uData?.ur_id,
              schema: config.schema,
            },
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              // Authorization: jwttoken,
            },
          },
        );

        const allELearnCourses = Array.from(
          new Set(res?.allCourse?.map((item) => item.tid)),
        ).map((id) => {
          return res?.allCourse?.find((item) => item.tid === id);
        });

        res.allCourse = allELearnCourses;
        const continueLearning = res?.allCourse?.filter(
          (completed) =>
            completed.sub_date !== null && completed.comp_date === null,
        );

        res.continueLearning = continueLearning;
        return res;
      } catch (err) {
        console.error(err.message);
      }
    },
  );

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  if (dashboardData.isError)
    return <h1>{JSON.stringify(dashboardData.error)}</h1>;

  // const PopularSession = userDetails &&
  //   dashboardData.data?.popularSession?.length > 0 && (
  //     <Box sx={{ m: { xs: 1, sm: 2, md: 3 } }}>
  //       <Stack
  //         direction="row"
  //         justifyContent="space-between"
  //         alignItems="center"
  //       >
  //         <HeadingPrimary>Popular Session</HeadingPrimary>
  //         {dashboardData.data?.popularSession?.length > 10 && (
  //           <CusLink
  //             to="/viewall"
  //             onClick={() => {
  //               dispatch(
  //                 sessionAll({
  //                   type: "session",
  //                   header: "Popular Session",
  //                   data: dashboardData.data?.popularSession,
  //                 })
  //               );
  //               navigate("/viewall");
  //             }}
  //           >
  //             View all
  //           </CusLink>
  //         )}
  //       </Stack>
  //       <Box sx={{ mt: 2 }} />
  //       <Slider {...settings}>
  //         {/* {dashboardData.data?.popularSession
  //           ?.slice(0, 10)
  //           ?.map((item, idx) => (
  //             <Stack direction="row" key={item?.sid + "UKddC"}>
  //               <CardPrimary
  //                 auth={true}
  //                 title={item.sn}
  //                 img={
  //                   item.sid &&
  //                   `https://${
  //                     config.aws_cloudfront_url
  //                   }/${config.aws_org_id.toLowerCase()}-resources/images/session-images/${
  //                     item.sid
  //                   }.png`
  //                 }
  //                 addToBookMarkList={() => {}}
  //                 addToFavorite={item.EI}
  //                 sessionType={item.stype}
  //                 sessionDate={
  //                   item.date_list
  //                     ? moment(
  //                         new Date(item.date_list[0].combineStartTime).getTime()
  //                       ).format("DD MMM YYYY")
  //                     : item.startdate
  //                     ? moment(parseInt(item.startdate)).format("DD MMM YYYY")
  //                     : "yet to be scheduled"
  //                 }
  //                 handleLocation={() => {
  //                   navigate(`/session?sid=${item.sid}`);
  //                   dispatch(session(item));
  //                 }}
  //               />
  //             </Stack>
  //           ))} */}

  //         {dashboardData.data?.popularSession
  //           ?.slice()
  //           ?.sort((a, b) => {
  //             const timeA = a.date_list?.[0]?.combineStartTime
  //               ? new Date(a.date_list[0].combineStartTime).getTime()
  //               : 0;

  //             const timeB = b.date_list?.[0]?.combineStartTime
  //               ? new Date(b.date_list[0].combineStartTime).getTime()
  //               : 0;

  //             return timeB - timeA;
  //           })
  //           ?.slice(0, 10)
  //           ?.map((item, idx) => (
  //             <Stack direction="row" key={item?.sid + "UKddC"}>
  //               <CardPrimary
  //                 auth={true}
  //                 title={item.sn}
  //                 img={
  //                   item.sid &&
  //                   `https://${
  //                     config.aws_cloudfront_url
  //                   }/${config.aws_org_id.toLowerCase()}-resources/images/session-images/${
  //                     item.sid
  //                   }.png`
  //                 }
  //                 addToBookMarkList={() => {}}
  //                 addToFavorite={item.EI}
  //                 sessionType={item.stype}
  //                 sessionDate={
  //                   item.date_list?.[0]?.combineStartTime
  //                     ? moment(
  //                         new Date(item.date_list[0].combineStartTime).getTime()
  //                       ).format("DD MMM YYYY")
  //                     : item.startdate
  //                     ? moment(parseInt(item.startdate)).format("DD MMM YYYY")
  //                     : "yet to be scheduled"
  //                 }
  //                 handleLocation={() => {
  //                   navigate(`/session?sid=${item.sid}`);
  //                   dispatch(session(item));
  //                 }}
  //               />
  //             </Stack>
  //           ))}
  //       </Slider>
  //     </Box>
  //   );

  // const PopularSession = userDetails &&
  //   dashboardData.data?.popularSession?.length > 0 && (
  //     <Box sx={{ m: { xs: 1, sm: 2, md: 3 } }}>
  //       <Stack
  //         direction="row"
  //         justifyContent="space-between"
  //         alignItems="center"
  //       >
  //         <HeadingPrimary>Popular Session</HeadingPrimary>
  //         {dashboardData.data?.popularSession?.length > 10 && (
  //           <CusLink
  //             to="/viewall"
  //             onClick={() => {
  //               dispatch(
  //                 sessionAll({
  //                   type: "session",
  //                   header: "Popular Session",
  //                   data: dashboardData.data?.popularSession,
  //                 }),
  //               );
  //               navigate("/viewall");
  //             }}
  //           >
  //             View all
  //           </CusLink>
  //         )}
  //       </Stack>
  //       <Box sx={{ mt: 2 }} />
  //       <Slider {...settings}>
  //         {dashboardData.data?.popularSession
  //           ?.filter((item) => {
  //             if (item.date_list?.[0]?.combineStartTime) {
  //               const sessionTime = new Date(
  //                 item.date_list[0].combineStartTime,
  //               );
  //               return sessionTime > new Date(); // keep only future sessions
  //             }

  //             if (item.startdate) {
  //               const sessionTime = new Date(parseInt(item.startdate));
  //               return sessionTime > new Date();
  //             }
  //             // If neither exists, keep it (not yet scheduled)
  //             return true;
  //           })
  //           ?.sort((a, b) => {
  //             const timeA = a.date_list?.[0]?.combineStartTime
  //               ? new Date(a.date_list[0].combineStartTime).getTime()
  //               : a.startdate
  //                 ? parseInt(a.startdate)
  //                 : 0;

  //             const timeB = b.date_list?.[0]?.combineStartTime
  //               ? new Date(b.date_list[0].combineStartTime).getTime()
  //               : b.startdate
  //                 ? parseInt(b.startdate)
  //                 : 0;

  //             return timeB - timeA;
  //           })
  //           ?.slice(0, 10)
  //           ?.map((item) => (
  //             <Stack direction="row" key={item?.sid + "UKddC"}>
  //               <CardPrimary
  //                 auth={true}
  //                 title={item.sn}
  //                 img={
  //                   item.sid &&
  //                   `https://${config.aws_cloudfront_url}/${config.aws_org_id.toLowerCase()}-resources/images/session-images/${item.sid}.png`
  //                 }
  //                 addToBookMarkList={() => {}}
  //                 addToFavorite={item.EI}
  //                 sessionType={item.stype}
  //                 sessionDate={
  //                   item.date_list?.[0]?.combineStartTime
  //                     ? moment(
  //                         new Date(
  //                           item.date_list[0].combineStartTime,
  //                         ).getTime(),
  //                       ).format("DD MMM YYYY")
  //                     : item.startdate
  //                       ? moment(parseInt(item.startdate)).format("DD MMM YYYY")
  //                       : "yet to be scheduled"
  //                 }
  //                 handleLocation={() => {
  //                   navigate(`/session?sid=${item.sid}`);
  //                   dispatch(session(item));
  //                 }}
  //               />
  //             </Stack>
  //           ))}
  //       </Slider>
  //     </Box>
  //   );

  const filteredPopularSessions = dashboardData.data?.popularSession?.filter(
    (item) => {
      if (item.date_list?.[0]?.combineStartTime) {
        const sessionTime = new Date(item.date_list[0].combineStartTime);
        return sessionTime > new Date();
      }
      if (item.startdate) {
        const sessionTime = new Date(parseInt(item.startdate));
        return sessionTime > new Date();
      }
      return true;
    },
  );

  const PopularSession = userDetails && filteredPopularSessions?.length > 0 && (
    <Box sx={{ m: { xs: 1, sm: 2, md: 3 } }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <HeadingPrimary>Popular Session</HeadingPrimary>
        {filteredPopularSessions?.length > 10 && (
          <CusLink
            to="/viewall"
            onClick={() => {
              dispatch(
                sessionAll({
                  type: "session",
                  header: "Popular Session",
                  data: filteredPopularSessions,
                }),
              );
              navigate("/viewall");
            }}
          >
            View all
          </CusLink>
        )}
      </Stack>
      <Box sx={{ mt: 2 }} />
      <Slider {...settings}>
        {filteredPopularSessions
          ?.sort((a, b) => {
            const timeA = a.date_list?.[0]?.combineStartTime
              ? new Date(a.date_list[0].combineStartTime).getTime()
              : a.startdate
                ? parseInt(a.startdate)
                : 0;

            const timeB = b.date_list?.[0]?.combineStartTime
              ? new Date(b.date_list[0].combineStartTime).getTime()
              : b.startdate
                ? parseInt(b.startdate)
                : 0;

            return timeA - timeB;
          })
          ?.slice(0, 10)
          ?.map((item) => (
            <Stack direction="row" key={item?.sid + "UKddC"}>
              <CardPrimary
                auth={true}
                title={item.sn}
                img={
                  item.sid &&
                  `https://${config.aws_cloudfront_url}/${config.aws_org_id.toLowerCase()}-resources/images/session-images/${item.sid}.png`
                }
                addToBookMarkList={() => {}}
                addToFavorite={item.EI}
                sessionType={item.stype}
                sessionDate={
                  item.date_list?.[0]?.combineStartTime
                    ? moment(
                        new Date(item.date_list[0].combineStartTime).getTime(),
                      ).format("DD MMM YYYY")
                    : item.startdate
                      ? moment(parseInt(item.startdate)).format("DD MMM YYYY")
                      : "yet to be scheduled"
                }
                handleLocation={() => {
                  navigate(`/session?sid=${item.sid}`);
                  dispatch(session(item));
                }}
              />
            </Stack>
          ))}
      </Slider>
    </Box>
  );

  const getSessionDate = (item) => {
    if (item.date_list?.[0]?.combineStartTime) {
      return new Date(item.date_list[0].combineStartTime).getTime();
    }
    if (item.startdate) {
      return parseInt(item.startdate);
    }
    return 0;
  };

  const BiracSession = userDetails &&
    dashboardData.data?.BiracSession?.length > 0 && (
      <Box sx={{ m: { xs: 1, sm: 2, md: 3 } }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <HeadingPrimary>DBT – USP – BIRAC Webinar series</HeadingPrimary>

          {dashboardData.data?.BiracSession?.length > 10 && (
            <CusLink
              to="/viewall"
              onClick={() => {
                dispatch(
                  sessionAll({
                    type: "session",
                    header: "Popular Session",
                    data: dashboardData.data?.popularSession,
                  }),
                );
                navigate("/viewall");
              }}
            >
              View all
            </CusLink>
          )}
        </Stack>
        {/* <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <img
            src={`https://${
              config.aws_cloudfront_url
            }/${config.aws_org_id.toLowerCase()}-resources/images/org-images/BIRAC_logo.png`}
            alt="logo"
            height="60"
          />
          <img
            style={{ marginRight: "100px" }}
            src={`https://${
              config.aws_cloudfront_url
            }/${config.aws_org_id.toLowerCase()}-resources/images/org-images/logo-dark.png`}
            alt="logo"
            height="60"
          />
        </div> */}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "20px",
            marginBottom: "1rem",
          }}
        >
          <img
            src={`https://${
              config.aws_cloudfront_url
            }/${config.aws_org_id.toLowerCase()}-resources/images/org-images/ministryofsciencelogo.png`}
            alt="logo"
            height="60"
          />
          <img
            src={`https://${
              config.aws_cloudfront_url
            }/${config.aws_org_id.toLowerCase()}-resources/images/org-images/logo-dark.png`}
            alt="logo"
            height="60"
          />

          <img
            src={`https://${
              config.aws_cloudfront_url
            }/${config.aws_org_id.toLowerCase()}-resources/images/org-images/BIRAC_logo_new.png`}
            alt="logo"
            height="60"
          />
        </div>

        <div>{dashboardData.data?.biractext}</div>
        <Box sx={{ mt: 2 }} />
        <Slider {...settings}>
          {dashboardData.data?.BiracSession?.sort(
            (a, b) => getSessionDate(a) - getSessionDate(b),
          )
            ?.slice(0, 10)
            ?.map((item, idx) => (
              <Stack direction="row" key={item?.sid + "UKddC"}>
                <CardPrimary
                  auth={true}
                  title={item.sn}
                  img={
                    item.sid &&
                    `https://${
                      config.aws_cloudfront_url
                    }/${config.aws_org_id.toLowerCase()}-resources/images/session-images/${
                      item.sid
                    }.png`
                  }
                  addToBookMarkList={() => {}}
                  addToFavorite={item.EI}
                  sessionType={item.stype}
                  sessionDate={
                    item.date_list
                      ? moment(
                          new Date(
                            item.date_list[0].combineStartTime,
                          ).getTime(),
                        ).format("DD MMM YYYY")
                      : item.startdate
                        ? moment(parseInt(item.startdate)).format("DD MMM YYYY")
                        : "yet to be scheduled"
                  }
                  handleLocation={() => {
                    navigate(`/session?sid=${item.sid}`);
                    dispatch(session(item));
                  }}
                />
              </Stack>
            ))}
        </Slider>
      </Box>
    );
  const RegisteredSession = userDetails &&
    dashboardData.data?.registered?.length > 0 && (
      <Box sx={{ m: { xs: 1, sm: 2, md: 3 } }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <HeadingPrimary>Registered Sessions</HeadingPrimary>
          {dashboardData.data?.registered?.length > 10 && (
            <CusLink
              to="/viewall"
              onClick={() => {
                dispatch(
                  sessionAll({
                    type: "session",
                    header: "Registered Sessions",
                    data: dashboardData.data?.registered,
                  }),
                );
                navigate("/viewall");
              }}
            >
              View all
            </CusLink>
          )}
        </Stack>
        <Box sx={{ mt: 2 }} />
        <Slider {...settings}>
          {dashboardData.data?.registered?.slice(0, 10)?.map((item, idx) => (
            <Stack direction="row" key={item?.sid + "UKddC"}>
              <CardPrimary
                auth={true}
                title={item.sn}
                img={
                  item.sid &&
                  `https://${
                    config.aws_cloudfront_url
                  }/${config.aws_org_id.toLowerCase()}-resources/images/session-images/${
                    item.sid
                  }.png`
                }
                addToBookMarkList={() => {}}
                addToFavorite={item.EI}
                sessionType={item.stype}
                sessionDate={
                  item.date_list
                    ? moment(
                        new Date(item.date_list[0].combineStartTime).getTime(),
                      ).format("DD MMM YYYY")
                    : item.startdate
                      ? moment(parseInt(item.startdate)).format("DD MMM YYYY")
                      : "yet to be scheduled"
                }
                handleLocation={() => {
                  navigate(`/session?sid=${item.sid}`);
                  dispatch(session(item));
                }}
              />
            </Stack>
          ))}
        </Slider>
      </Box>
    );

  const AllCourse = dashboardData.data?.allCourse?.length > 0 && (
    <Box sx={{ m: { xs: 1, sm: 2, md: 3 } }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <HeadingPrimary>Self-paced Courses</HeadingPrimary>
        {dashboardData.data?.allCourse?.length > 10 && (
          <CusLink
            to="/viewall"
            onClick={() => {
              dispatch(
                sessionAll({
                  type: "course",
                  header: "Self-paced courses",
                  data: dashboardData.data?.allCourse,
                }),
              );
              navigate("/viewall");
            }}
          >
            View all
          </CusLink>
        )}
      </Stack>
      <Slider {...cardSecondarySettings}>
        {/* {[...Array(5)].map((item, idx) => ( */}
        {dashboardData.data?.allCourse?.slice(0, 10)?.map((item, idx) => (
          <CardSecondary
            key={idx}
            img={
              item?.tid &&
              `https://${
                config.aws_cloudfront_url
              }/${config.aws_org_id.toLowerCase()}-resources/images/topic-images/${
                item?.tid
              }.png`
            }
            title={
              item?.ttitle.length > 30
                ? item?.ttitle.substring(0, 30) + "..."
                : item?.ttitle
            }
            sessionDate={
              item.startdate &&
              moment(parseInt(item.startdate)).format("DD MMM YYYY")
            }
            handleLocation={() => {
              navigate(`/course?id=${item?.tid}`);
              dispatch(session({ ...item }));
            }}
            nonug={item?.noofnuggets}
          />
        ))}
        {/* ))} */}
      </Slider>
    </Box>
  );
  // const PopularCourse = dashboardData.data?.popularCourse?.length > 0 && (
  //   <Box sx={{ m: { xs: 1, sm: 2, md: 3 } }}>
  //     <Stack direction="row" justifyContent="space-between" alignItems="center">
  //       <HeadingPrimary>Popular Course</HeadingPrimary>
  //       {dashboardData?.data?.popularCourse?.length > 10 && (
  //         <CusLink
  //           to="/viewall"
  //           onClick={() => {
  //             dispatch(
  //               sessionAll({
  //                 type: "course",
  //                 header: "Popular Course",
  //                 data: dashboardData?.data?.popularCourse,
  //               })
  //             );
  //             navigate("/viewall");
  //           }}
  //         >
  //           View all
  //         </CusLink>
  //       )}
  //     </Stack>
  //     <Slider {...cardSecondarySettings}>
  //       {/* {[...Array(5)].map((item, idx) => ( */}
  //       {dashboardData?.data?.popularCourse?.slice(0, 10)?.map((item, idx) => (
  //         <CardSecondary
  //           key={idx}
  //           img={
  //             item?.tid &&
  //             `https://${
  //               config.aws_cloudfront_url
  //             }/${config.aws_org_id.toLowerCase()}-resources/images/topic-images/${
  //               item?.tid
  //             }.png`
  //           }
  //           title={item?.tn}
  //           sessionDate={
  //             item.startdate &&
  //             moment(parseInt(item.startdate)).format("DD MMM YYYY")
  //           }
  //           handleLocation={() => {
  //             navigate(`/course?id=${item?.tid}`);
  //             dispatch(session({ ...item }));
  //           }}
  //           nonug={item?.nugcnt}
  //         />
  //       ))}
  //       {/* ))} */}
  //     </Slider>
  //   </Box>
  // );
  const PopularCourse = data?.course?.length > 0 && (
    <Box sx={{ m: { xs: 1, sm: 2, md: 3 } }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <HeadingPrimary>Popular courses</HeadingPrimary>
        {data?.course?.length > 10 && (
          <CusLink
            to="/viewall"
            onClick={() => {
              dispatch(
                sessionAll({
                  type: "course",
                  header: "Popular courses",
                  data: data?.course,
                }),
              );
              navigate("/viewall");
            }}
          >
            View all
          </CusLink>
        )}
      </Stack>
      <Slider {...cardSecondarySettings}>
        {/* {[...Array(5)].map((item, idx) => ( */}
        {data?.course?.slice(0, 10)?.map((item, idx) => (
          <CardSecondary
            key={idx}
            img={
              item?.tid &&
              `https://${
                config.aws_cloudfront_url
              }/${config.aws_org_id.toLowerCase()}-resources/images/topic-images/${
                item?.tid
              }.png`
            }
            title={item?.tn}
            sessionDate={
              item.startdate &&
              moment(parseInt(item.startdate)).format("DD MMM YYYY")
            }
            handleLocation={() => {
              navigate(`/course?id=${item?.tid}`);
              dispatch(session({ ...item }));
            }}
            nonug={item?.nugcnt}
          />
        ))}
        {/* ))} */}
      </Slider>
    </Box>
  );
  const ContinueLearning = dashboardData.data?.continueLearning?.length > 0 && (
    <Box sx={{ m: { xs: 1, sm: 2, md: 3 } }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <HeadingPrimary>Continue Learning</HeadingPrimary>
        {dashboardData.data?.continueLearning?.length > 10 && (
          <CusLink
            to="/viewall"
            onClick={() => {
              dispatch(
                sessionAll({
                  type: "course",
                  header: "Continue Learning",
                  data: dashboardData.data?.continueLearning,
                }),
              );
              navigate("/viewall");
            }}
          >
            View all
          </CusLink>
        )}
      </Stack>
      <Slider {...cardSecondarySettings}>
        {/* {[...Array(5)].map((item, idx) => ( */}
        {dashboardData.data?.continueLearning
          ?.slice(0, 10)
          ?.map((item, idx) => (
            <CardSecondary
              key={idx}
              img={
                item?.tid &&
                `https://${
                  config.aws_cloudfront_url
                }/${config.aws_org_id.toLowerCase()}-resources/images/topic-images/${
                  item?.tid
                }.png`
              }
              title={item?.ttitle}
              sessionDate={
                item.startdate &&
                moment(parseInt(item.startdate)).format("DD MMM YYYY")
              }
              handleLocation={() => {
                navigate(`/course?id=${item?.tid}`);
                dispatch(session({ ...item }));
              }}
              nonug={item?.noofnuggets}
            />
          ))}
        {/* ))} */}
      </Slider>
    </Box>
  );
  const CompletedCourse = dashboardData.data?.completedcourses?.length > 0 && (
    <Box sx={{ m: { xs: 1, sm: 2, md: 3 } }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <HeadingPrimary>Completed Self-paced Courses</HeadingPrimary>
        {dashboardData.data?.completedcourses?.length && (
          <CusLink
            to="/viewall"
            onClick={() => {
              dispatch(
                sessionAll({
                  type: "course",
                  header: "Completed self-paced course",
                  data: dashboardData.data?.completedCourse,
                }),
              );
              navigate("/viewall");
            }}
          >
            View all
          </CusLink>
        )}
      </Stack>
      <Slider {...cardSecondarySettings}>
        {/* {[...Array(5)].map((item, idx) => ( */}
        {dashboardData.data?.completedcourses
          ?.slice(0, 10)
          ?.map((item, idx) => (
            <CardSecondary
              key={idx}
              img={
                item?.tid &&
                `https://${
                  config.aws_cloudfront_url
                }/${config.aws_org_id.toLowerCase()}-resources/images/topic-images/${
                  item?.tid
                }.png`
              }
              title={item?.ttitle}
              sessionDate={
                item.startdate &&
                moment(parseInt(item.startdate)).format("DD MMM YYYY")
              }
              handleLocation={() => {
                navigate(`/course?id=${item?.tid}`);
                dispatch(session({ ...item }));
              }}
              nonug={item?.noofnuggets}
            />
          ))}
        {/* ))} */}
      </Slider>
    </Box>
  );

  const categoriesWithCourses =
    dashboardData?.data?.mycategories?.filter((category) =>
      dashboardData?.data?.allCourse?.some(
        (course) => Number(course?.cgry_id) === Number(category?.id),
      ),
    ) || [];
  const myTopics = dashboardData.data?.mycategories?.length > 0 && (
    <Box sx={{ m: { xs: 1, sm: 2, md: 3 } }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <HeadingPrimary>Subjects</HeadingPrimary>
        {/* {dashboardData.data?.mycategories?.length && (
        <CusLink
          to="/viewall"
          onClick={() => {
            // Get all category IDs from mycategories
            const categoryIds = dashboardData.data?.mycategories?.map(
              (cat) => cat?.id
            );

            // Filter allCourse where cgry_id matches any of the category IDs
            const filteredCourses = dashboardData.data?.allCourse?.filter(
              (course) => categoryIds?.includes(course?.cgry_id)
            );

            dispatch(
              sessionAll({
                type: "Mytopics",
                header: "Subjects",
                data: filteredCourses,
                
                allCourses:dashboardData.data?.allCourse
              })
            );
            navigate("/viewall");
          }}
        >
          View all
        </CusLink> */}
        {dashboardData.data?.mycategories?.length && (
          <CusLink
            to="/viewall"
            onClick={() => {
              dispatch(
                sessionAll({
                  type: "myTopics",
                  header: "Subjects",
                  data: categoriesWithCourses,
                  allCourses: dashboardData.data?.allCourse,
                }),
              );
              navigate("/viewall");
            }}
          >
            View all
          </CusLink>
        )}
      </Stack>

      <Slider {...settings}>
        {/* {[...Array(5)].map((item, idx) => ( */}
        {categoriesWithCourses.map((item, idx) => (
          <CardTopicsSecondary
            key={idx}
            img={
              item?.id &&
              `https://${
                config.aws_cloudfront_url
              }/${config.aws_org_id.toLowerCase()}-resources/images/category-images/${
                item?.ct_img
              }`
            }
            title={item?.name}
            handleLocation={() => {
              const filteredCourses = dashboardData.data?.allCourse?.filter(
                (course) => course.cgry_id === item?.id,
              );

              dispatch(
                sessionAll({
                  type: "course",
                  header: item?.name,
                  data: filteredCourses,
                }),
              );
              navigate("/viewall");
            }}
          />
        ))}
        {/* ))} */}
      </Slider>
    </Box>
  );
  const UpcomingSession = userDetails &&
    dashboardData.data?.upcoming?.length > 0 && (
      <Box sx={{ m: { xs: 1, sm: 2, md: 3 }, mt: 100 }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <HeadingPrimary>Upcoming Sessions</HeadingPrimary>
          {dashboardData.data?.upcoming?.length > 10 && (
            <CusLink
              to="/viewall"
              onClick={() => {
                dispatch(
                  sessionAll({
                    type: "session",
                    header: "Upcoming Sessions",
                    data: dashboardData?.data?.upcoming,
                  }),
                );
                navigate("/viewall");
              }}
            >
              View all
            </CusLink>
          )}
        </Stack>
        <Box sx={{ mt: 2 }} />
        <Slider {...settings}>
          {dashboardData.data?.upcoming
            ?.sort((a, b) => {
              const timeA = a.date_list?.[0]?.combineStartTime
                ? new Date(a.date_list[0].combineStartTime).getTime()
                : a.startdate
                  ? parseInt(a.startdate)
                  : 0;

              const timeB = b.date_list?.[0]?.combineStartTime
                ? new Date(b.date_list[0].combineStartTime).getTime()
                : b.startdate
                  ? parseInt(b.startdate)
                  : 0;

              return timeA - timeB;
            })
            .slice(0, 10)
            ?.map((item, idx) => (
              <Stack direction="row" key={idx + "UKC"}>
                <CardPrimary
                  auth={true}
                  title={item.sn}
                  img={
                    item.sid &&
                    `https://${
                      config.aws_cloudfront_url
                    }/${config.aws_org_id.toLowerCase()}-resources/images/session-images/${
                      item.sid
                    }.png`
                  }
                  addToBookMarkList={() => {}}
                  addToFavorite={item.EI}
                  sessionType={item.stype}
                  sessionDate={
                    item.date_list
                      ? item.date_list[0]?.date === ""
                        ? "yet to be scheduled"
                        : moment(
                            new Date(
                              item.date_list[0].combineStartTime,
                            ).getTime(),
                          ).format("DD MMM YYYY")
                      : item.startdate
                        ? moment(parseInt(item.startdate)).format("DD MMM YYYY")
                        : "yet to be scheduled"
                  }
                  handleLocation={() => {
                    navigate(`/session?sid=${item.sid}`);
                    dispatch(session(item));
                  }}
                />
              </Stack>
            ))}
        </Slider>
      </Box>
    );

  // const OnGoingSession = userDetails &&
  //   dashboardData.data?.ongoing?.length > 0 && (
  //     <Box sx={{ m: { xs: 1, sm: 2, md: 3 }, mt: 100 }}>
  //       <Stack
  //         direction="row"
  //         justifyContent="space-between"
  //         alignItems="center"
  //       >
  //         <HeadingPrimary>Ongoing Sessions</HeadingPrimary>
  //         {dashboardData.data?.ongoing?.length > 10 && (
  //           <CusLink
  //             to="/viewall"
  //             onClick={() => {
  //               dispatch(
  //                 sessionAll({
  //                   type: "session",
  //                   header: "Upcoming Sessions",
  //                   data: dashboardData.data?.ongoing,
  //                 })
  //               );
  //               navigate("/viewall");
  //             }}
  //           >
  //             View all
  //           </CusLink>
  //         )}
  //       </Stack>
  //       <Box sx={{ mt: 2 }} />
  //       <Slider {...settings}>
  //         {dashboardData.data?.ongoing?.slice(0, 10)?.map((item, idx) => (
  //           <Stack direction="row" key={idx + "UKC"}>
  //             <CardPrimary
  //               auth={true}
  //               title={item.sn}
  //               img={
  //                 item.sid &&
  //                 `https://${
  //                   config.aws_cloudfront_url
  //                 }/${config.aws_org_id.toLowerCase()}-resources/images/session-images/${
  //                   item.sid
  //                 }.png`
  //               }
  //               addToBookMarkList={() => {}}
  //               addToFavorite={item.EI}
  //               sessionType={item.stype}
  //               sessionDate={
  //                 item.date_list
  //                   ? item.date_list[0]?.date === ""
  //                     ? "yet to be scheduled"
  //                     : moment(
  //                         new Date(item.date_list[0].combineStartTime).getTime()
  //                       ).format("DD MMM YYYY")
  //                   : item.startdate
  //                   ? moment(parseInt(item.startdate)).format("DD MMM YYYY")
  //                   : "yet to be scheduled"
  //               }
  //               handleLocation={() => {
  //                 navigate(`/session?sid=${item.sid}`);
  //                 dispatch(session(item));
  //               }}
  //             />
  //           </Stack>
  //         ))}
  //       </Slider>
  //     </Box>
  //   );

  const CompletedSession = dashboardData.data?.completed?.length > 0 && (
    <Box sx={{ m: { xs: 1, sm: 2, md: 3 } }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <HeadingPrimary>Completed Sessions</HeadingPrimary>
        {dashboardData.data?.completed?.length > 10 && (
          <CusLink
            to="/viewall"
            onClick={() => {
              dispatch(
                sessionAll({
                  type: "session",
                  header: "Completed Sessions",
                  data: dashboardData?.data?.completed,
                }),
              );
              navigate("/viewall");
            }}
          >
            View all
          </CusLink>
        )}
      </Stack>
      <Box sx={{ mt: 2 }} />
      <Slider {...settings}>
        {dashboardData?.data?.completed.slice(0, 10).map((item, idx) => (
          <Stack direction="row" key={idx + "DCS"}>
            <CardPrimary
              auth={true}
              title={item.sn}
              img={
                item.sid &&
                `https://${
                  config.aws_cloudfront_url
                }/${config.aws_org_id.toLowerCase()}-resources/images/session-images/${
                  item.sid
                }.png`
              }
              addToBookMarkList={() => {}}
              addToFavorite={item.EI}
              sessionType={item.stype}
              sessionDate={
                item.date_list
                  ? moment(
                      new Date(item.date_list[0].combineStartTime).getTime(),
                    ).format("DD MMM YYYY")
                  : item.startdate
                    ? moment(parseInt(item.startdate)).format("DD MMM YYYY")
                    : "yet to be scheduled"
              }
              handleLocation={() => {
                navigate(`/session?sid=${item.sid}`);
                dispatch(session(item));
              }}
            />
          </Stack>
        ))}
      </Slider>
    </Box>
  );

  return (
    <>
      {dashboardData.isLoading && <SkeletonData />}
      {!dashboardData.isLoading && UpcomingSession}
      {!dashboardData.isLoading && BiracSession}
      {!dashboardData.isLoading && PopularSession}
      {!dashboardData.isLoading && CompletedCourse}
      {!dashboardData.isLoading && AllCourse}
      {!dashboardData.isLoading && RegisteredSession}
      {!dashboardData.isLoading && ContinueLearning}

      {!dashboardData.isLoading && PopularCourse}

      {/* {!dashboardData.isLoading && OnGoingession} */}
      {!dashboardData.isLoading && CompletedSession}

      {!dashboardData.isLoading && myTopics}

      {dashboardData.data?.allCourse?.length === 0 &&
        dashboardData.data?.completedCourse?.length === 0 &&
        data?.course?.length === 0 &&
        dashboardData.data?.myTopics?.length === 0 &&
        dashboardData.data?.continueLearning?.length === 0 &&
        dashboardData.data?.upcoming?.length === 0 &&
        dashboardData.data?.completed?.length === 0 &&
        dashboardData.data?.popularSession?.length === 0 &&
        dashboardData.data?.ongoing?.length === 0 &&
        dashboardData.data?.registered?.length === 0 && (
          <div
            style={{
              height: "60vh",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <img src={emptysearch} alt="emptysearch" />
          </div>
        )}
    </>
  );
}
